import { render, staticRenderFns } from "./DriverNavigation.vue?vue&type=template&id=60ff26de&scoped=true&"
import script from "./DriverNavigation.vue?vue&type=script&lang=js&"
export * from "./DriverNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DriverNavigation.vue?vue&type=style&index=0&id=60ff26de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff26de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
